import React from 'react';
import TaskTemplates from '../../TaskTemplates';

const TaskTemplate = () => {
  return <TaskTemplates embedded />;
};

export default TaskTemplate;
